export const MA_COMPANY_ADDRESSES_LOADER = {
  desktop: `
<div class="cui-grid cui-container -spacing--top-64 -spacing--bottom-120">
  <div class="cui-row">
    <div class="cui-col-xl-10 col-offset-xl-1">
      <div class="cui-skeleton-paragraph -spacing--bottom-40">
        <div class="cui-skeleton-paragraph__content" style="width: 160px">
          <div class="cui-skeleton__item" style="height: 16px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -spacing--bottom-40 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-16 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="-spacing--bottom-24" style="display: flex; justify-content: space-between; align-items: center; column-gap: 16px">
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
      </div>
      <div class="cui-skeleton-button -size--medium -spacing--bottom-64">
        <div class="cui-skeleton-button__content">
          <div class="cui-skeleton__item cui-skeleton-button__button" style="width:156px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-16 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="-spacing--bottom-24" style="display: flex; justify-content: space-between; align-items: center; column-gap: 16px">
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
      </div>
      <div class="cui-skeleton-button -size--medium">
        <div class="cui-skeleton-button__content">
          <div class="cui-skeleton__item cui-skeleton-button__button" style="width:156px"></div>
        </div>
      </div>
     </div>
  </div>
</div>`,
  mobile: `
<div class="cui-grid cui-container -spacing--top-24 -spacing--bottom-64">
  <div class="cui-row">
    <div class="cui-col-xl-10 col-offset-xl-1">
      <div class="cui-skeleton-paragraph -spacing--bottom-24">
        <div class="cui-skeleton-paragraph__content" style="width: 160px">
          <div class="cui-skeleton__item" style="height: 16px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--mobile">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-16 -resolution--mobile">
        <div class="cui-skeleton-heading__content">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="-spacing--bottom-24" style="display: flex; justify-content: space-between; align-items: center; column-gap: 16px">
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
      </div>
      <div class="cui-skeleton-button -size--medium -spacing--bottom-40" style="width:100%">
        <div class="cui-skeleton-button__content" style="width:inherit">
          <div class="cui-skeleton__item cui-skeleton-button__button" style="width:inherit"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-16 -resolution--mobile">
        <div class="cui-skeleton-heading__content">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="-spacing--bottom-24" style="display: flex; justify-content: space-between; align-items: center; column-gap: 16px">
        <div class="cui-skeleton-rectangle" style="flex-grow: 1">
          <div class="cui-skeleton__item" style="height: 244px;"></div>
        </div>
      </div>
      <div class="cui-skeleton-button -size--medium" style="width:100%">
        <div class="cui-skeleton-button__content" style="width:inherit">
          <div class="cui-skeleton__item cui-skeleton-button__button" style="width:inherit"></div>
        </div>
      </div>
     </div>
  </div>
</div>`
};
